import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type StatusNoticeTone = "info" | "success" | "warning" | "error";
type StatusNoticeLayout = "bar" | "panel";

type StatusNoticeProps = {
  tone: StatusNoticeTone;
  layout: StatusNoticeLayout;
  children: ReactNode;
  title?: ReactNode;
  icon?: ReactNode;
  className?: string;
};

export default function StatusNotice({
  tone,
  layout,
  children,
  title,
  icon,
  className,
}: StatusNoticeProps) {
  const layoutTextClassName =
    layout === "bar" ? "text-[0.75rem] leading-[1.5]" : "text-sm leading-[1.55]";

  return (
    <div
      className={cn(
        "theme-status-notice",
        `theme-status-notice--${tone}`,
        `theme-status-notice--${layout}`,
        layoutTextClassName,
        className
      )}
    >
      {title || icon ? (
        <div className="theme-status-notice__header">
          {icon ? (
            <span className="theme-status-notice__icon" aria-hidden="true">
              {icon}
            </span>
          ) : null}
          <div className="min-w-0">
            {title ? (
              <p className="theme-status-notice__title">{title}</p>
            ) : null}
            <div className="theme-status-notice__body">{children}</div>
          </div>
        </div>
      ) : (
        <div className="theme-status-notice__body">{children}</div>
      )}
    </div>
  );
}
